import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material'

export type TermsAndConditionsProps = {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export function TermsAndConditions({
  open,
  setOpen,
}: Readonly<TermsAndConditionsProps>) {
  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h6" fontWeight="bold">
          Privacy & Legal
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
          <Typography variant="body2" sx={styles.text}>
            Last Updated: October 2023
          </Typography>
          <Typography variant="body2" sx={styles.text}>
            Welcome to Aye, your trusted source for cutting-edge AI solutions...
          </Typography>

          <Typography variant="h6" sx={styles.subheader}>
            Privacy Policy
          </Typography>
          <Typography variant="body2" sx={styles.text}>
            1. Information Collection
          </Typography>
          <Typography variant="body2" sx={styles.text}>
            1.1. We may collect personal information, such as name, email...
          </Typography>
          {/* Repeat for all other content just like above */}

          <Typography variant="h6" sx={styles.subheader}>
            Terms of Service
          </Typography>
          <Typography variant="body2" sx={styles.text}>
            Last Updated: Oct 2023
          </Typography>
          <Typography variant="body2" sx={styles.text}>
            These Terms of Service ("Terms") govern your use of our website...
          </Typography>
          {/* Continue rendering the rest of the content similarly */}

          <Typography variant="h6" sx={styles.subheader}>
            Legal Disclaimer
          </Typography>
          <Typography variant="body2" sx={styles.text}>
            1. Terms of Service
          </Typography>
          <Typography variant="body2" sx={styles.text}>
            1.1. Review our Terms of Service for information...
          </Typography>
          <Typography variant="body2" sx={styles.text}>
            Contact Us: <a href="mailto:info@aye-ai.org">info@aye-ai.org</a>
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => setOpen(false)}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const styles = {
  text: {
    marginTop: 1,
    marginBottom: 1,
  },
  subheader: {
    marginTop: 3,
    marginBottom: 1,
    fontWeight: 'bold',
  },
}
